import { CustomModalProps, Modal } from '@dynamika-shared/ui/Modal/Modal';
import { ModalProps } from 'antd';
import { FC, useMemo } from 'react';
import { VisitsModalType } from './ClinicalTrialVisits';
import { twMerge } from '@utils/twMerge';

type ConfirmationProps = {
  modalType: VisitsModalType;
  onCancel: () => void;
  onOk: () => void;
  navigate: () => void;
  loading: boolean;
};

export const ConfirmationVisits: FC<ConfirmationProps> = ({
  modalType,
  onCancel,
  onOk,
  navigate,
  loading,
}) => {
  const confirmationMode: Record<
    VisitsModalType,
    Partial<ModalProps & CustomModalProps>
  > = useMemo(
    () => ({
      NO_LABELS: {
        children: (
          <>
            You cannot create a visit because you <br />
            don't have any labels. Please add labels <br />
            to your Clinical Trial
          </>
        ),
        title: 'No labels found',
        onOk: () => {
          onCancel();
          navigate();
        },
        okProps: {
          disabled: loading,
        },
        onCancel,
      },
      DELETE_VISIT: {
        children: (
          <>
            Are you sure you want to delete <br />
            the Visit?
          </>
        ),
        title: 'Delete Visit',
        onCancel,
        cancelText: 'Cancel',
        onOk,
        okProps: {
          disabled: loading,
        },
        okText: 'Delete',
      },
      DELETE_COHORT: {
        children: (
          <>
            Are you sure you want to delete <br />
            the Cohort with all associated visits?
          </>
        ),
        title: 'Delete Cohort',
        onCancel,
        cancelText: 'Cancel',
        onOk,
        okText: 'Delete',
      },
    }),
    [onCancel, onOk]
  );
  return (
    <Modal
      {...confirmationMode[modalType]}
      data-testid={'confirmation-visits'}
      open={!!modalType}
      width={440}
      centered
      maskClosable={false}
      mask={false}
      okClassName={twMerge(modalType !== 'NO_LABELS' && 'ant-btn-dangerous')}
      titleClassName='text-left'
      classNames={{
        header: 'text-left',
        content: 'text-center !rounded-[2.4rem] !p-[4rem]',
        footer: 'flex justify-center',
      }}
    />
  );
};
